import { createRouter, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import FirstView from '../views/FirstView.vue'
import MessageView from '../views/MessageView.vue'
import SearchView from '../views/SearchView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: FirstView
  },
  {
    path: '/Default.aspx',
    name: 'Default',
    component: FirstView
  },
  {
    path: '/first',
    name: 'first',
    component: FirstView
  },
  {
    path: '/comment',
    name: 'comment',
    component: MessageView
  },
  {
    path: '/search',
    name: 'search',
    component: SearchView
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
